<template>
  <div class="import-wrapper">
    <div class="box-imp">
      <b-form-file
        class="imp-file"
        v-model="file"
        accept="text/csv"
        :state="Boolean(file)"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
        @input="onInput"
      ></b-form-file>
      <div class="mt-2 template" @click.prevent="onDownload">
        Download Template
      </div>
    </div>
    <div class="box-imp my-3">
      <b-form-textarea
        class="import-content"
        id="textarea"
        v-model="content"
        :placeholder="`stage;saruId,saruId;itemId,itemId,ItemId\nstage;saruId;itemId,ItemId`"
        rows="14"
        :state="isValid"
        @change="onchange"
      ></b-form-textarea>
    </div>
    <b-row>
      <b-col cols="12" md="6">
        <span class="text-muted">Max Stage</span>
        <span class="font-weight-bold ml-2">{{ maxStage }}</span>
      </b-col>
      <b-col cols="12" md="6" class="text-right">
        <span class="text-muted">Estimate Gas</span>
        <span class="font-weight-bold ml-2">
          {{ utils.bigToCommon(estimate, 0, 0) }}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="12">
        <span class="text-muted">Max Reward</span>
        <span class="font-weight-bold ml-2"
          >{{ utils.bigToCommon(maxReward) }} Hash Rate</span
        >
      </b-col>
    </b-row>
    <div class="box-imp d-flex justify-content-end align-items-center my-3">
      <div class="d-flex">
        <b-btn class="px-3 btn-action" @click="$emit('close')">Close</b-btn>
        <b-btn class="ml-3 px-3 btn-action btn-update" @click="onApply">
          Apply
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
// import jsonFormat from "json-format";
import { debounce, values, keys, max, sum } from "lodash";
import { ethers } from "ethers";
import CoreGame from "@/amakunicom/sdk/core-game";
import Referral from "@/amakunicom/sdk/referral";
import exportFromJson from "export-from-json";

export default {
  name: "ImportTeam",
  computed: {
    isValid() {
      try {
        return !!this.team;
      } catch {
        return false;
      }
    },
  },
  data: () => ({
    team: null,
    content: "",
    file: null,
    copied: false,
    estimate: ethers.constants.Zero,
    maxStage: 0,
    maxReward: 0,
  }),
  async created() {
    this.tokens = this.getCoreConfig();
    this.signer = await this.provider.getSigner();
    this.account = await this.signer.getAddress();
    this.game = new CoreGame(this.tokens, this.provider, this.signer);
    this.referral = new Referral(this.tokens.referral, this.provider);
    let value = this.mStore.getImportTeam();
    if (value) {
      try {
        const { team } = this.mStore.decrypt(value);
        this.team = this.utils.toImportTeam(team.split(/\r\n|\n|\r/));
        this.content = team;
        this.onUpdate();
      } catch (err) {
        this.team = null;
      }
    }
    // this.onUpdate();
  },
  methods: {
    async onApply() {
      if (this.content) {
        this.team = this.utils.toImportTeam(this.content.split(/\r\n|\n|\r/));
      }
      if (this.isValid) {
        this.mStore.setImportTeam(this.mStore.encrypt({ team: this.content }));
        this.$bvModal.hide("import-team-modal");
        this.$eventBus.$emit("saru-load-import", true);
        const data = this.utils.toImportTeam(this.content.split(/\r\n|\n|\r/));
        const stage = await this.game.stageOf(this.account);
        if (data && data.length > 1 && data[1] && data[1][stage]) {
          const { itemList, tokenIds } = data[1][stage];
          if (itemList && tokenIds) {
            await this.$store.dispatch("saru/updateTeam", {
              tokenIds,
              itemIds: itemList,
            });
            this.$eventBus.$emit("saru-load-data");
          }
        }
      } else {
        this.$bvToast.show("tx-warning");
      }
    },
    onInput(f) {
      const self = this;
      const reader = new FileReader();
      reader.onload = ({ target: { result } }) => {
        let rows = result
          .replace(/["]/g, "")
          .replace(/ /g, "")
          .split(/\r\n|\n|\r/);
        rows = rows.filter((row) => {
          const cols = row.split(/;/);
          return (
            cols.length > 1 &&
            self.utils.parseBigInt(cols[0]) &&
            cols[1].length > 0
          );
        });
        [self.team] = self.utils.toImportTeam(rows);
        self.content = rows.join("\n");
        this.onUpdate();
      };
      reader.onerror = (err) => console.log(err);
      reader.readAsText(f);
    },
    async onUpdate() {
      try {
        const self = this;
        let dataTeam;
        [this.team, dataTeam] = this.utils.toImportTeam(
          this.content.split(/\r\n|\n|\r/)
        );
        this.estimate = ethers.constants.Zero;
        if (self.team) {
          const gas = await Promise.all(
            self.team.map((val) =>
              this.game.estimateGasfighting(keys(val), values(val))
            )
          );
          gas.forEach((g) => (self.estimate = self.estimate.add(g)));
        }

        try {
          const stages = keys(dataTeam).map((t) => Number(t));
          self.maxStage = max(stages);
          this.maxReward = sum(stages.map((t) => t * 10));
          this.maxReward = await this.referral.refPoint(
            this.account,
            this.maxReward
          );
        } catch (error) {
          self.maxStage = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    onchange() {
      debounce(this.onUpdate, 2000);
    },
    onEncodeTeam() {
      return this.mStore.encrypt({ team: this.content.replace(/["]/g, "") });
    },
    async onCopied() {
      this.copied = true;
      const code = this.mStore.getMyRef();
      await this.$clipboard(
        `${window.location.origin}?ip=${this.onEncodeTeam()}&code=${code}`
      );
      await new Promise((r) => setTimeout(r, 1000));
      this.copied = false;
    },
    onLink() {
      const ip = this.onEncodeTeam();
      const code = this.mStore.getMyRef();
      const { href } = this.$router.resolve({
        name: "QuickEarn",
        query: { ip, code },
      });
      window.open(href, "_blank");
    },
    onDownload() {
      const list = [
        { STAGE: 1, SARU: "7655", ITEMS: "" },
        { STAGE: 2, SARU: "7658", ITEMS: "372" },
        { STAGE: 3, SARU: "7658,7657", ITEMS: "372,921,800" },
      ];
      exportFromJson({
        data: list,
        fileName: "kuni-team",
        exportType: "csv",
        delimiter: ";",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.import-wrapper {
  .box-imp {
    .imp-file {
      &.is-invalid {
        .custom-file-label {
          background-color: transparent;
          border-color: aqua;
        }
      }
    }

    .template {
      text-decoration: underline;
      color: #eb345f;
      cursor: pointer;
      font-size: 15px;
    }

    .import-content {
      background-color: transparent;
    }
    .btn-action {
      border: 1px solid #eb345f;
      background-color: transparent;
      &.btn-update {
        border: none;
        background-color: #eb345f;
        &:hover,
        &:focus,
        &:active {
          background-color: #eb345f;
          box-shadow: none !important;
        }
      }
      font-weight: 600;
      border-radius: 8px;
      &:hover,
      &:focus,
      &:active {
        box-shadow: none !important;
      }
    }
    .share-link {
      cursor: pointer;
      text-decoration: underline;
    }
    .w-copied {
      cursor: pointer;
      color: #eb345f;
    }
  }
}
</style>
